import React, { Component } from "react"
import Layout from "../components/Layout/Layout"
import Seo from "../components/Core/Seo"
import { graphql } from "gatsby"
import get from "lodash/get"
import LayeredNavigation from "../components/Plp/LayeredNavigation"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { replaceMaterialWord } from "../services/material"
import { mapProductsWithImages } from "../services/images"

class MaterialTemplate extends Component {
  render() {
    const path = this.props.location.pathname
    const products = mapProductsWithImages(get(this, "props.data.products.products"))
    const productsByTag = mapProductsWithImages(get(this, "props.data.productsByTag.nodes"))
    const productsByContentfulTag = mapProductsWithImages(get(
      this,
      "props.data.productsByContentfulTag.nodes"
    ))
    const weddingBands = mapProductsWithImages(get(this, "props.data.weddingBands.nodes"))

    let category = get(this, "props.data.category")
    const alternatePath = get(this, "props.pageContext.alternatePath")
    const handle = get(this, "props.pageContext.handle")
    const videos = get(this, "props.data.video.nodes")
    const videoUrl = videos[0].video.file.url
    const productContents = get(this, "props.data.productContents.nodes")
    const { metaTitle, metaDescription } = category
    let material = this.props.pageContext.material

    let localisedHandle = ""

    if (category) {
      localisedHandle = category.urlKey
    }
    let goldMetaTitle = metaTitle
    let goldMetaDescription = metaDescription
    if (material) {
      goldMetaTitle = replaceMaterialWord(goldMetaTitle, material.color)
      goldMetaDescription = replaceMaterialWord(
        goldMetaDescription,
        material.color
      )
    }

    const pathWithAlternateMaterial = path.replace(
      material.handle,
      material.alternateHandle
    )

    let filteredProducts = []

    if (products) {
      filteredProducts = products
    }

    if (category.handle === "engagement-rings") {
      filteredProducts = filteredProducts.filter(
        (product) =>
          product.productType !== "Band" &&
          product.productType !== "Diamond" &&
          product.productType !== "Wedding Band"
      )
    }

    if (productsByTag || productsByContentfulTag) {
      const filteredProductNames = filteredProducts.map((product) =>
        product.title.toLowerCase()
      )

      if (productsByTag) {
        productsByTag.forEach((product) => {
          if (!filteredProductNames.includes(product.title.toLowerCase())) {
            filteredProducts.push(product)
          }
        })
      }

      if (productsByContentfulTag) {
        productsByContentfulTag.forEach((product) => {
          if (!filteredProductNames.includes(product.title.toLowerCase())) {
            filteredProducts.push(product)
          }
        })
      }
    }

    if (handle === "all-our-products") {
      if (weddingBands?.length > 0) {
        filteredProducts = [...filteredProducts, ...weddingBands]
      }
    }

    return (
      <Layout
        alternatePath={pathWithAlternateMaterial.replace(
          localisedHandle,
          alternatePath.trim()
        )}
      >
        <Seo
          title={goldMetaTitle}
          description={goldMetaDescription}
          fullTitle={true}
          path={path}
          alternatePath={pathWithAlternateMaterial.replace(
            localisedHandle,
            alternatePath.trim()
          )}
        />
        <LayeredNavigation
          category={category}
          products={filteredProducts}
          material={material}
          videoUrl={videoUrl}
          productContents={productContents}
        />
      </Layout>
    )
  }
}

export default withTranslation()(MaterialTemplate)

export const pageQuery = graphql`
  query MaterialQuery(
    $handle: String!
    $locale: String!
    $productsByContentfulTag: [String!]
    $language: String!
  ) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    category: contentfulCollectionContent(
      handle: { eq: $handle }
      node_locale: { eq: $locale }
    ) {
      metaTitle
      description {
        raw
      }
      metaDescription
      title
      handle
      descriptionTitle
      activeLocale
      urlKey
      showStagingProduct
      h1
      activeLocale
      urlKey
      heroImage {
        gatsbyImageData(width: 1920, quality: 90)
        description
        title
      }
      mobileHeroImage {
        gatsbyImageData(width: 1400, quality: 90)
        description
        title
      }
      isEngagement
      heroTextColour
    }
     products: shopifyCollection(handle: { eq: $handle }) {
      products {
        ...ProductCardFragment
      }
    }
    productsByTag: allShopifyProduct(filter: { tags: { in: [$handle] } }) {
      nodes {
        ...ProductCardFragment
      }
    }
    productsByContentfulTag: allShopifyProduct(
      filter: { handle: { in: $productsByContentfulTag } }
    ) {
      nodes {
        ...ProductCardFragment
      }
    }
    weddingBands: allShopifyProduct(
      filter: {
        tags: { in: ["ring", "Ring", "rings", "Rings"] }
        productType: { eq: "Wedding Band" }
      }
    ) {
      nodes {
        ...ProductCardFragment
      }
    }
    productContents: allContentfulProductContent(
      filter: { node_locale: { eq: $locale } }
    ) {
      nodes {
        ...ProductCardContentFragment
      }
    }
    video: allContentfulBlockVideo(
      filter: { title: { eq: "Process Video" }, node_locale: { eq: $locale } }
    ) {
      nodes {
        video {
          id
          file {
            url
          }
        }
      }
    }
  }
`
